import React, { ReactNode, FC } from "react";

import {
  Drawer as ChakraDrawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerContentProps,
  DrawerCloseButton,
  DrawerProps as ChakraDrawerProps,
} from "@chakra-ui/modal";

export interface DrawerProps extends ChakraDrawerProps {
  children: ReactNode;
  header?: ReactNode;
  closeButtonDisabled?: boolean;
  drawerContentContainerStyle?: DrawerContentProps;
}

export const Drawer: FC<DrawerProps> = ({
  children,
  header,
  placement,
  closeButtonDisabled,
  drawerContentContainerStyle,
  ...props
}) => {
  return (
    <ChakraDrawer placement={placement} variant={placement} {...props}>
      <DrawerOverlay onClick={props.onClose} />
      <DrawerContent {...drawerContentContainerStyle}>
        <DrawerHeader>
          {header}
          {!closeButtonDisabled && <DrawerCloseButton />}
        </DrawerHeader>
        <DrawerBody paddingX={4}>{children}</DrawerBody>
      </DrawerContent>
    </ChakraDrawer>
  );
};
